import React from "react";
import { useTranslation } from "react-i18next";

function ChinWooOverview() {
  const { t } = useTranslation();

  const infoCards = [
    {
      icon: "fas fa-globe",
      title: t("chinwooOverview.details.detail1.subtitle"),
      description: t("chinwooOverview.details.detail1.text"),
    },
    {
      icon: "fas fa-leaf",
      title: t("chinwooOverview.details.detail2.subtitle"),
      description: t("chinwooOverview.details.detail2.text"),
    },
    {
      icon: "fas fa-dove",
      title: t("chinwooOverview.details.detail3.subtitle"),
      description: t("chinwooOverview.details.detail3.text"),
    },
    {
      icon: "fas fa-users",
      title: t("chinwooOverview.details.detail4.subtitle"),
      description: t("chinwooOverview.details.detail4.text"),
    },
  ];

  return (
    <section className="pt-24 pb-12 bg-slate-50/50 dark:bg-slate-900 transition-colors" id="chinwoo-overview">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-8 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("chinwooOverview.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
          <p className="text-slate-600 dark:text-slate-400 mt-4 text-lg max-w-3xl mx-auto">
            {t("chinwooOverview.description")}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {infoCards.map((card, index) => (
            <div
              key={index}
              className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6 hover:shadow-md transition-all duration-200"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                {/* Icon */}
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-primary/10 dark:bg-primary-light/20 flex items-center justify-center">
                  <i className={`${card.icon} text-primary dark:text-primary-light text-2xl`}></i>
                </div>
                
                {/* Content */}
                <div className="space-y-2">
                  <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
                    {card.title}
                  </h3>
                  <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ChinWooOverview;
